
<div class="layout-wrapper landing section intro-section pb-0">
<div class="institution-page-container" [dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">

  <section class="hero-section py-5">
    <div class="container">
      <h1 class="display-4 mb-3 text-center">{{ 'institution.page.hero.heading' | translate }}</h1>
      <p class="lead">{{ 'institution.page.hero.paragraph1' | translate }}</p>
      <p>{{ 'institution.page.hero.paragraph2' | translate }}</p>
      <p>{{ 'institution.page.hero.paragraph3' | translate }}</p>
     
    </div>
    <!-- Sign Up -->
    <div *ngIf="!userData" class="text-center mt-4">
      <button class="btn btn-primary" (click)="openRoleModal('InstitutionLeader')">
        {{ 'general.signup' | translate }}
      </button>
    </div>
  </section>

  <section class="features-section bg-light py-5">
    <div class="container">
      <h2 class="text-center mb-5">{{ 'institution.page.features.heading' | translate }}</h2>
      <div class="row text-center">
        <div class="col-md-4 mb-4">
          <div class="feature-icon mb-3">
            <i class="mdi mdi-cogs display-4 text-primary"></i> </div>
          <h4>{{ 'institution.page.features.feature1.title' | translate }}</h4>
          <p class="text-muted">{{ 'institution.page.features.feature1.description' | translate }}</p>
        </div>
        <div class="col-md-4 mb-4">
          <div class="feature-icon mb-3">
            <i class="mdi mdi-chart-bar display-4 text-primary"></i> </div>
          <h4>{{ 'institution.page.features.feature2.title' | translate }}</h4>
          <p class="text-muted">{{ 'institution.page.features.feature2.description' | translate }}</p>
        </div>
        <div class="col-md-4 mb-4">
          <div class="feature-icon mb-3">
             <i class="mdi mdi-link-variant display-4 text-primary"></i> </div>
          <h4>{{ 'institution.page.features.feature3.title' | translate }}</h4>
          <p class="text-muted">{{ 'institution.page.features.feature3.description' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="about-section py-5">
      <div class="container">
          <div class="row align-items-center">
              <div class="col-lg-6 mb-4 mb-lg-0">
                  <img src="assets/images/dojo/institution-solution.png" alt="{{ 'institution.page.about.heading' | translate }}" class="img-fluid rounded">
              </div>
              <div class="col-lg-6">
                  <h2 class="mb-3">{{ 'institution.page.about.heading' | translate }}</h2>
                  <p>{{ 'institution.page.about.paragraph1' | translate }}</p>
                  <p>{{ 'institution.page.about.paragraph2' | translate }}</p>
              </div>
          </div>
      </div>
  </section>

  </div>
</div>
<app-role-modal 
  [isModalOpen]="isModalVisible"
  [selectedRole]="selectedRole"
  [(emailAddress)]="userEmail"
  (close)="handleModalClose()"
  (continueEvent)="handleModalContinue($event)">
</app-role-modal>